/** Equivalent of Lodash times() function */
export function times(n: number): number[] {
  return Array.from({ length: n }, (_, i) => i)
}

/** Creates a duplicate-free version of an array */
export function unique<T>(array: T[]): T[] {
  return Array.from(new Set(array))
}
